export function housePropertyConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 150,
    column: [{
        label: "房产证号/合同编号",
        prop: "idNumber",
        width: 140,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "权属人",
        prop: "owner",
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "地址",
        prop: "addresss",


      }, {
        label: "用途",
        prop: "usageReason",


      }, {
        label: "出证/购买时间",
        prop: "buytime",
        type: "date",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        width: 140,
      }, {
        label: "建筑面积",
        prop: 'archAreaF',
        disabled: false,
        append: '平方米',
        hide: true,
      }, {
        label: "建筑面积（平方米）",
        prop: 'archArea',
        disabled: false,
        append: '平方米',
        display: false,
        width: 140,
      }, {
        label: "对应土地面积",
        prop: 'landAreaF',
        disabled: false,
        append: '平方米',
        hide: true,

      }, {
        label: "对应土地面积（平方米）",
        prop: 'landArea',
        disabled: false,
        append: '平方米',
        display: false,
        width: 160,

      }, {
        label: "原始投入价",
        prop: 'originMoneyF',
        disabled: false,
        append: '万元',
        hide: true,

      }, {
        label: "原始投入价（万元）",
        prop: 'originMoney',
        disabled: false,
        append: '万元',
        display: false,
        width: 140,

      }, {
        label: "市场估价",
        prop: 'marketMoneyF',
        disabled: false,
        append: '万元',
        hide: true,
      }, {
        label: "市场估价（万元）",
        prop: 'marketMoney',
        disabled: false,
        append: '万元',
        display: false,
        width: 140,
      }, {
        label: "是否已抵押或按揭",
        prop: "isMortgage",
        type: "radio",
        span: 12,
        width: 160,
        value: 0,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],

      }, {
        label: "抵押银行",
        prop: 'mortgage',
        display: false,
      }, {
        label: "抵押金额（万元）",
        prop: 'mortgageMoney',
        append: '万元',

        display: false,
        width: 140,
      }, {
        label: "是否出租",
        prop: "isLease",
        type: "radio",
        span: 12,
        value: 0,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],

      },
      {
        label: "备注",
        type: 'textarea',
        prop: "remarks",
        span: 24

      }

    ]
  }
}

export function landPropertyConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 150,
    column: [{
        label: "土地证号/合同编号",
        prop: "idNumber",
        width: 140,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "权属人",
        prop: "owner",
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "地址",
        prop: "addresss",


      }, {
        label: "用地性质",
        prop: "usageReason",


      }, {
        label: "出证/购买时间",
        prop: "buytime",
        type: "date",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        width: 140,
      }, {
        label: "建筑面积",
        prop: 'archAreaF',
        disabled: false,
        append: '平方米',
        hide: true,
      }, {
        label: "建筑面积（平方米）",
        prop: 'archArea',
        disabled: false,
        append: '平方米',
        display: false,
        width: 140,
      }, {
        label: "土地面积",
        prop: 'landAreaF',
        disabled: false,
        append: '平方米',
        hide: true,

      }, {
        label: "土地面积（平方米）",
        prop: 'landArea',
        disabled: false,
        append: '平方米',
        display: false,
        width: 160,

      }, {
        label: "原始投入价",
        prop: 'originMoneyF',
        disabled: false,
        append: '万元',
        hide: true,

      }, {
        label: "原始投入价（万元）",
        prop: 'originMoney',
        disabled: false,
        append: '万元',
        display: false,
        width: 140,

      }, {
        label: "市场估价",
        prop: 'marketMoneyF',
        disabled: false,
        append: '万元',
        hide: true,
      }, {
        label: "市场估价（万元）",
        prop: 'marketMoney',
        disabled: false,
        append: '万元',
        display: false,
        width: 140,
      }, {
        label: "是否已抵押或按揭",
        prop: "isMortgage",
        type: "radio",
        span: 12,
        width: 160,
        value: 0,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],

      }, {
        label: "抵押银行",
        prop: 'mortgage',

        display: false,
      }, {
        label: "抵押金额（万元）",
        prop: 'mortgageMoney',
        append: '万元', 
        display: false,
        width: 140,
      }, {
        label: "是否出租",
        prop: "isLease",
        type: "radio",
        span: 12,
        value: 0,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],

      },
      {
        type: 'textarea',
        label: "备注",
        prop: "remarks",
        span: 24
      }

    ]
  }
}

export function carPropertyConfig() {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 150,
    column: [{
        label: "车牌",
        prop: "carNumber",
        width: 140,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "权属人",
        prop: "owner",
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "车辆型号",
        prop: "carType",


      }, {
        label: "原始投入价",
        prop: 'originMoneyF',
        disabled: false,
        append: '万元',
        hide: true,

      }, {
        label: "原始投入价（万元）",
        prop: 'originMoney',
        disabled: false,
        append: '万元',
        display: false,
        width: 140,

      }, {
        label: "市场估价",
        prop: 'marketMoneyF',
        disabled: false,
        append: '万元',
        hide: true,
      }, {
        label: "市场估价（万元）",
        prop: 'marketMoney',
        disabled: false,
        append: '万元',
        display: false,
        width: 140,
      }, {
        label: "是否已抵押或按揭",
        prop: "isMortgage",
        type: "radio",
        span: 12,
        width: 160,
        value: 0,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],

      }, {
        label: "抵押方",
        prop: 'mortgage',
        display: false,
      }, {
        label: "抵押金额（万元）",
        prop: 'mortgageMoney',
        append: '万元',
        display: false,
        width: 140,
      }, {
        label: "是否出租",
        prop: "isLease",
        type: "radio",
        span: 12,
        value: 0,
        dicData: [{
            label: "否",
            value: 0,
          },
          {
            label: "是",
            value: 1,
          },

        ],

      },
      {
        label: "备注",
        type: 'textarea',
        prop: "remarks",
        span: 24

      }

    ]
  }
}
